module.exports = __webpack_public_path__ + "img/license_image4.acc04db3.png";